import { render, staticRenderFns } from "./InternationDialog.vue?vue&type=template&id=27fddba0&scoped=true&"
import script from "./InternationDialog.vue?vue&type=script&lang=js&"
export * from "./InternationDialog.vue?vue&type=script&lang=js&"
import style0 from "./InternationDialog.vue?vue&type=style&index=0&id=27fddba0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fddba0",
  null
  
)

export default component.exports